import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export default function useValidateOnLanguageChange(validateFunc: () => any | Promise<any>) {
    const validateFuncRef = useRef(validateFunc);
    const {
        i18n: { language }
    } = useTranslation();
    useEffect(() => {
        validateFuncRef.current = validateFunc;
    }, [validateFunc]);
    useEffect(() => {
        validateFuncRef.current && validateFuncRef.current();
    }, [language]);
}
